import { useEffect } from "react"
import { useNavigate } from "react-router"

export default function PageNotFound() {
    const navigate = useNavigate()
    useEffect(() => {
        setTimeout(() => {
            navigate('/dashboard')
        }, 5000)
    }, [navigate])

    return (
        <div>
            404 Page Not Found.
        </div>
    )
}